export default "__VITE_ASSET__e2cddc0f__"